export default __webpack_public_path__ + "static/logo-d3a2fa9ea9dd2417c355db245d5ffc3b.png";